module.exports = __webpack_public_path__ + "static/media/terms&conditions.87e01a86.svg";